module.exports = __webpack_public_path__ + "static/media/a27.a4d6d8ec.jpg";